// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1D1M1","options":"AnswerScale_options__2bjYY","selected":"AnswerScale_selected__1eC5P"};